import React from 'react';
import Webinar711Background from 'assets/main_lobby/webinar-scmp711.png';
import LobbyLink711Template from './LobbyLink711Template';

const Webinar711Template = () => (
  <LobbyLink711Template background={Webinar711Background} />
);

export default Webinar711Template;
